export const OPEN_CREATE_NEW_CARD = 'OPEN_CREATE_NEW_CARD';
export const CLOSE_CREATE_NEW_CARD = 'CLOSE_CREATE_NEW_CARD';
export const GET_CARDS = 'GET_CARDS';
export const SET_CARDS = 'SET_CARDS';
export const SHOW_CARD_INFO = 'SHOW_CARD_INFO';
export const HIDE_CARD_INFO = 'HIDE_CARD_INFO';
export const OPEN_PASSWORD_MODAL = 'OPEN_PASSWORD_MODAL';
export const CLOSE_PASSWORD_MODAL = 'CLOSE_PASSWORD_MODAL';
export const UPDATE_CARDS_METADATA = 'UPDATE_CARDS_METADATA';
export const SET_CARD = 'SET_CARD';
export const OPEN_CARD_FORM_MODAL = 'OPEN_CARD_FORM_MODAL';
export const CLOSE_CARD_FORM_MODAL = 'CLOSE_CARD_FORM_MODAL';
export const OPEN_EDIT_CARD_FORM_MODAL = 'OPEN_EDIT_CARD_FORM_MODAL';
export const CLOSE_EDIT_CARD_FORM_MODAL = 'CLOSE_EDIT_CARD_FORM_MODAL';
export const HIDE_CARD_FORM_MODAL = 'HIDE_CARD_FORM_MODAL';
export const SHOW_CARD_FORM_MODAL = 'SHOW_CARD_FORM_MODAL';
export const OPEN_USER_FORM_MODAL = 'OPEN_USER_FORM_MODAL';
export const CLOSE_USER_FORM_MODAL = 'CLOSE_USER_FORM_MODAL';
export const OPEN_PHYSICAL_CARD_FORM_MODAL = 'OPEN_PHYSICAL_CARD_FORM_MODAL';
export const CLOSE_PHYSICAL_CARD_FORM_MODAL = 'CLOSE_PHYSICAL_CARD_FORM_MODAL';
export const OPEN_SHIPPING_ADDRESS_MODAL = 'OPEN_SHIPPING_ADDRESS_MODAL';
export const CLOSE_SHIPPING_ADDRESS_MODAL = 'CLOSE_SHIPPING_ADDRESS_MODAL';
export const OPEN_CONFIRM_ADDRESS_MODAL = 'OPEN_CONFIRM_ADDRESS_MODAL';
export const CLOSE_CONFIRM_ADDRESS_MODAL = 'CLOSE_CONFIRM_ADDRESS_MODAL';
export const OPEN_CONFIRM_EXIT_DIALOG = 'OPEN_CONFIRM_EXIT_DIALOG';
export const CLOSE_CONFIRM_EXIT_DIALOG = 'CLOSE_CONFIRM_EXIT_DIALOG';
export const SET_FORM_SUMITTING = 'SET_FORM_SUMITTING';
export const UPDATE_CARD_LIST = 'UPDATE_CARD_LIST';
export const LOAD_MCC_CODE = 'LOAD_MCC_CODE';
export const SAVE_TOKENS = 'SAVE_TOKENS';
export const REMOVE_FRAME = 'REMOVE_FRAME';
export const ERROR_FRAMES = 'ERROR_FRAMES';
export const CARD_FORM_ERROR = 'CARD_FORM_ERROR';
export const GET_CARDHOLDERS = 'GET_CARDHOLDERS';
export const OPEN_NO_BALANCE_MODAL = 'OPEN_UNALLOCATED_BALANCE_MODAL';
export const CLOSE_NO_BALANCE_MODAL = 'CLOSE_NO_BALANCE_MODAL';
export const OPEN_EDIT_CARD_FUNDS_MODAL = 'OPEN_EDIT_CARD_FUNDS_MODAL';
export const CLOSE_EDIT_CARD_FUNDS_MODAL = 'CLOSE_EDIT_CARD_FUNDS_MODAL';
export const OPEN_REQUEST_NEW_CARD = 'OPEN_REQUEST_NEW_CARD';
export const CLOSE_REQUEST_CARD_FORM_MODAL = 'CLOSE_REQUEST_CARD_FORM_MODAL';
export const OPEN_REVIEW_NEW_CARD = 'OPEN_REVIEW_NEW_CARD';
export const CLOSE_REVIEW_CARD_FORM_MODAL = 'CLOSE_REVIEW_CARD_FORM_MODAL';
export const OPEN_REQUEST_EDIT_CARD_LIMIT = 'OPEN_REQUEST_EDIT_CARD_LIMIT';
export const CLOSE_REQUEST_EDIT_CARD_LIMIT_MODAL = 'CLOSE_REQUEST_EDIT_CARD_LIMIT_MODAL';
